import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {Loner} from "../../../Loner";
import {gsap} from "gsap"
import {LonerPinTheWinConerMultiView} from "./LonerPinTheWinConerMultiView";
import {extraInfoForPin, LonerPinTheWinPinMovingView} from "./LonerPinTheWinPinMovingView";
import {LonerPinTheWinVHSView} from "./LonerPinTheWinVHSView";
import {LonerGameMode} from "../../../server/LonerGameMode";
import {MotionPathPlugin} from "gsap/dist/MotionPathPlugin";
import {Trail} from "../../../components/Trail";

export class LonerPinTheWinMainView extends PIXI.Container implements StageLayer {
    private _isRestore: boolean = false;
    private _cornerMultipliers: LonerPinTheWinConerMultiView;
    private _movingPin: LonerPinTheWinPinMovingView;

    constructor() {
        super();
        gsap.registerPlugin(MotionPathPlugin);
        this.init();
        this.name = "pinTheWinMainView";
    }


    public setPinPosAndVisibility(reelId: number, symId: number, visible: boolean, druation: number = 0.5): gsap.core.Timeline {
        const tl: gsap.core.Timeline = new gsap.core.Timeline();
        tl.add([this._movingPin.setPinPosAndVisibility(reelId, symId, visible, druation), () => {
            this._movingPin.setEyesCurrentPos(reelId, symId);
        }]);
        return tl;
    }

    public movePin(destReelId: number, destSymId: number, extraInfoForPin: extraInfoForPin): gsap.core.Timeline {
        const tl: gsap.core.Timeline = new gsap.core.Timeline();
        tl.add(this._movingPin.movePin(destReelId, destSymId, extraInfoForPin));
        return tl;
    }

    public showCornerMultipliers(duration: number = 0.5): gsap.core.Timeline {
        const tl: gsap.core.Timeline = new gsap.core.Timeline();
        tl.add(this._cornerMultipliers.showMultipliers(duration));
        return tl;
    }

    public showHideBg(visible: boolean, durr: number): gsap.core.Timeline {
        return gsap.timeline().add(this._movingPin.showHideBg(visible, durr));
    }

    public showVhsMulti(duration: number = 0.5): gsap.core.Timeline {
        return new gsap.core.Timeline().add(Loner.pinTheWinVHSView.showMulti(duration));
    }

    public hideVhsMulti(duration: number = 0.5): gsap.core.Timeline {
        return new gsap.core.Timeline().add(Loner.pinTheWinVHSView.hideMulti(duration));
    }

    public hideCornerMultipliers(duration: number = 0.5): gsap.core.Timeline {
        const tl: gsap.core.Timeline = new gsap.core.Timeline();
        tl.add(this._cornerMultipliers.hideMultipliers(duration));
        return tl;
    }

    public stopMaxWinSymbolBlink(): void {
        this._cornerMultipliers.stopMaxWinSymbolBlink();
    }

    public setAllCornerMulti(setNextCornerValue: boolean = false): gsap.core.Timeline {
        return new gsap.core.Timeline().add(() => {
            this._cornerMultipliers.setAllMultiValue(setNextCornerValue);
        })
    }

    public setVhsMulti(value: number): gsap.core.Timeline {
        return new gsap.core.Timeline().add(() => {
            Loner.pinTheWinVHSView.setMulti(value)
        });
    }

    public clearTrail(): void {
        this._movingPin.clearTrail();
    }

    private init(): void {
        this._cornerMultipliers = new LonerPinTheWinConerMultiView();
        this._movingPin = new LonerPinTheWinPinMovingView();
        this.addChild(this._cornerMultipliers, this._movingPin);
        this._isRestore = Loner.model.initData && Loner.model.initData.isRestoreState && (Loner.model.mode === LonerGameMode.FEATURE_PIN_THE_WIN || Loner.model.nextMode === LonerGameMode.FEATURE_PIN_THE_WIN);
        this.visible = false;
    }

    get isRestore(): boolean {
        return this._isRestore
    }

    set isRestore(value: boolean) {
        this._isRestore = value;
    }
}